<template>
    <div class="Mbusiness">
        <div class="pic">
            <img src="../../assets/img/tool－bg.png" alt="">
        </div>
        <main class="business-main">
            <img src="../../assets/img/tools－image－1.png" alt="">
            <img src="../../assets/img/tools－image－2.png" alt="">
            <img src="../../assets/img/tools－image－3.png" alt="">
            <img src="../../assets/img/tools－image－4.png" alt="">
        </main>
    </div>
</template>

<script>
    export default {
        name: 'Mbusiness',
        data() {
            return {

            }
        }
    }
</script>


<style scoped lang='scss'>
    .pic {
        img {
            width: 100%;
        }
    }

    .business-main {
        margin-bottom: 4%;

        img {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/Mbusiness.vue